<template>
  <div id="examuser">
    <van-divider>考试工作人员</van-divider>
    <van-cell>
      <template slot="icon">
        <i class="fa fa-fw fa-group fa-lg mt-2 mr-1"></i>
      </template>
      <template slot="title">
        <!-- {{option1[value1].text}} -->
        <el-select v-model="value1" placeholder="请选择" size="mini">
          <el-option
            v-for="item in option1"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
        <span class="ml-4" v-if="data">{{data.length ? "" + data.length + "人" : "空"}}</span>
      </template>
    </van-cell>
    <div class="text-left">
      <van-cell-group>
        <template slot="title" v-if="value1 == 0">
          <van-button type="primary" size="small" round class="w-100" @click="batBtn">批量通过审核</van-button>
        </template>
        <van-cell v-for="(item, index) in data" :key="index" size="large">
          <template slot="icon" v-if="value1 == 0">
            <van-checkbox v-model="item.checked" shape="square" class="mr-2"></van-checkbox>
          </template>
          <template slot="icon" v-else>
            <van-icon name="user-o" size="22px" class="mr-2" />
          </template>
          <template slot="title">
            <b class="mr-2" @click="showformBtn(item)">{{item.RealName}}</b>
            <small>{{item.OrganName}}</small>
          </template>
          <template slot="label">
            <small>
              <van-icon name="phone" />联系电话:
              <a class="color-blue" :href="'tel:' + item.Phone">{{item.Phone}}</a>
            </small>
            <br />
            <small>
              <van-icon name="newspaper-o" />申请考试
              <b class="color-black">{{ item.RoleName }}</b>
              , 申请时间{{ item.ApplyTime }}日
            </small>
            <br />
            <small>
              <van-icon name="edit" />当前审核状态
              <b
                :class="statusColor[item.Status].color"
                @click="showformBtn(item)"
              >{{ option1[item.Status].text }}</b>
            </small>
          </template>
          <template slot="default" v-if="false">
            <van-icon name="ellipsis" class="color-black" size="22px" @click="showformBtn(item)" />
          </template>
          <template slot="right-icon">
            <van-icon
              name="ellipsis"
              class="color-black ml-2"
              size="22px"
              @click="showformBtn(item)"
            />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <!-- 操作对话框 -->
    <van-popup v-model="sheet1" position="bottom" class="popup-l3" closeable round>
      <div class="m-4">
        <h3>参与考试申请</h3>
        <van-divider>审核考试工作人员</van-divider>
        <van-cell-group>
          <van-field>
            <template slot="label">状态</template>
            <template slot="input">
              <van-radio-group v-model="sheet1content.Status">
                <van-radio class="mb-2" :name="1">通过</van-radio>
                <van-radio class="mb-2" :name="2">驳回</van-radio>
                <van-radio class="mb-2" :name="3">驳回可再申请</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-show="sheet1content.Status != 1"
            v-model="sheet1content.Memo"
            rows="2"
            autosize
            label="备注"
            type="textarea"
            maxlength="50"
            placeholder="请输入留言"
            show-word-limit
          />
        </van-cell-group>
        <van-button type="info" class="w-100 mt-4" @click="updateBtn">提交</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "organuser",
  data() {
    return {
      data: [],
      value1: 0,
      option1: [
        { text: "未审核", value: 0 },
        { text: "已参与", value: 1 },
        { text: "已驳回", value: 2 },
        { text: "驳回可再申请", value: 3 },
        { text: "全部申请记录", value: -1 }
      ],
      statusColor: [
        { color: "color-yellow" },
        { color: "color-green" },
        { color: "color-gray" },
        { color: "color-black" }
      ],
      sheet1: false,
      sheet1content: {
        Status: 1,
        OpenID: "",
        RangeID: 0,
        RoleID: 0,
        OrganID: "",
        Memo: ""
      },
      sheet2: false,
      sheet2content: {
        FileID: "",
        TableList: [],
        TableName: ""
      },
      sheet3: false,
      sheet3content: {
        isDrawLots: true, //是否在系统内抽签开关变量
        data: []
      },
      sheet4: false,
      sheet4content: {
        data: [],
        resultmessage: ""
      },
      params: {
        WorkID: this.getWork().WorkID,
        SplitProcessID: this.SplitProcessID,
        RadRoomUser: 0,
        FileID: "",
        TableName: "",
        Fields: {
          RoomNo: "",
          UserName: "",
          Tel: "",
          UserType1: "",
          UserType2: "",
          UserType3: ""
        }
      }
    };
  },
  watch: {
    value1() {
      /* newVal, oldVal */
      this.drawData();
    }
  },
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  methods: {
    //上传进度
    drawData() {
      this.apiExamOrganUserMobileAPIGet(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID,
          OrganID: this.getAddr().OrganID,
          RoleID: this.getAddr().RoleID,
          RangeID: this.getAddr().RangeID,
          Status: this.value1,
          UserType: this.getAuth().UserType
        },
        this,
        res => {
          this.data = res.data;
        }
      );
    },
    /* 显示审核操作窗口按钮 */
    showformBtn(item) {
      this.sheet1content.OpenID = item.OpenID;
      this.sheet1content.RangeID = item.RangeID;
      this.sheet1content.RoleID = item.RoleID;
      this.sheet1content.OrganID = item.OrganID;
      this.sheet1 = true;
    },
    /* 批量通过审核 */
    batBtn() {
      this.data.forEach(item => {
        if (item.checked) {
          // console.log("data", item);
          this.apiExamOrganUserMobileAPIPut(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: this.SplitProcessID,
              Status: 1,
              OpenID: item.OpenID,
              RangeID: item.RangeID,
              RoleID: item.RoleID,
              OrganID: item.OrganID,
              Memo: ""
            },
            this,
            res => {
              if (res.code == 20000) {
                this.$toast(res.message);
                this.drawData();
              }
            }
          );
        }
      });
    },
    /* 修改工作人员申请考试审核状态 */
    updateBtn() {
      this.sheet1content.WorkID = this.getWork().WorkID;
      this.sheet1content.SplitProcessID = this.SplitProcessID;
      this.apiExamOrganUserMobileAPIPut(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID,
          Status: this.sheet1content.Status,
          OpenID: this.sheet1content.OpenID,
          RangeID: this.sheet1content.RangeID,
          RoleID: this.sheet1content.RoleID,
          OrganID: this.sheet1content.OrganID,
          Memo: this.sheet1content.Memo
        },
        this,
        res => {
          this.$toast(res.message);
          if (res.code == 20000) {
            //重置申请状态处理页面内容
            this.sheet1 = false;
            this.sheet1content.OpenID = "";
            this.sheet1content.Status = 1;
            this.sheet1content.Memo = "";
            this.sheet1content.RangeID = 0;
            this.sheet1content.RoleID = 0;
            this.sheet1content.OrganID = "";
            //刷新数据
            this.drawData();
          }
        }
      );
    }
  },
  created() {
    this.drawData();
  }
};
</script>

<style scoped>
</style>